import { render } from "./connectionIcon.svg?vue&type=template&id=2b788759"
const script = {}
script.render = render

export default script